import React from "react";
import PropTypes from "prop-types";
import { InlineTabs } from "components/common/inline-tabs";

export const AutomateInlineTabs = ({ currentPage, slug }) => (
  <span className="automate2">
    <InlineTabs tabValues={ tabValues(currentPage, slug) } />
  </span>
);

AutomateInlineTabs.propTypes = {
  currentPage: PropTypes.oneOf(["manage-categories", "manage-vendors"]).isRequired,
  slug: PropTypes.string.isRequired
};

const tabValues = (currentPage, slug) => (
  [
    {
      name: "Manage Categories",
      path: `/accounts/${slug}/automate/manage-categories`,
      isSelected: currentPage === "manage-categories"
    },
    {
      name: "Manage Vendors",
      path: `/accounts/${slug}/automate/manage-vendors`,
      isSelected: currentPage === "manage-vendors"
    }
  ]
);



// WEBPACK FOOTER //
// ./src/js/components/common/automate-inline-tabs.jsx